enum ProjectionProviderByEnum {
  NPI = "npi",
  TIN = "tin",
  NPIAndTIN = "npiAndTin",
  ContractEntity = "contractEntity",
  Name = "name",
}

export default ProjectionProviderByEnum;